<template>
  <modal name="sign-modal"
         width="800px"
         height="500px"
         :clickToClose="false"
         @opened="opened">
    <div class="h-100" style="z-index: 1500">
      <div class="p-2" style="height: calc(100% - 40px)">
        <h5 class="modal-title m-1">Signature  </h5>
        <div class="border w-100" style="height: calc(100% - 40px)"><VueSignaturePad ref="signaturePad" /></div>
      </div>
      <div class="vue-dialog-buttons" style="height: 40px">
        <button type="button" class="vue-dialog-button" style="flex: 1 1 33%;" @click="cancel">Annuler</button>
        <button type="button" class="vue-dialog-button" style="flex: 1 1 33%;" @click="clear">Recommencer</button>
        <button type="button" class="vue-dialog-button" style="flex: 1 1 33%;" @click="save">Sauver</button>
      </div>
    </div>
  </modal>
</template>
<script>
export default {
  props: {
      value: String
  },
  methods: {
    opened() {
      //Don't load previous signature
      // if(this.value != null)
      //     this.$refs.signaturePad.fromDataURL(this.value)
    },
    cancel () {
      this.$modal.hide('sign-modal')
    },
    clear () {
      this.$refs.signaturePad.clearSignature()
    },
    save () {
      const { isEmpty, data } = this.$refs.signaturePad.saveSignature("image/svg+xml")
      if(isEmpty) { 
        alert('La signature est vide !')
      }
      else {
        this.$emit('input', data)
        this.$modal.hide('sign-modal')
      }
    }
  }
}
</script>

<style type="text/css">
.vm--container {
  z-index: 1500 !important;
}
.vm--modal {
  z-index: 1600 !important;
  max-height: 100%;
}
</style>